import React from 'react';
import { Download, BookOpen, Award } from 'lucide-react';
import useMyTeamStore from '@/stores/AdminStore/MyTeamStore';
import './LearningHistoryTab.css';

const LearningHistoryTab: React.FC = () => {
  const { teamMembers, learningHistory } = useMyTeamStore();
  return (
    <div className="admin-my-team-history">
      <div className="admin-my-team-history-header">
        <div>
          <h2 className="admin-my-team-section-title">Learning History</h2>
          <p className="admin-my-team-section-subtitle">Select a team member to view their learning history</p>
        </div>
        <div className="admin-my-team-history-actions">
          <select className="admin-my-team-select">
            <option>All team Members</option>
            {teamMembers?.map(member => (
              <option key={member.id}>{member.name}</option>
            ))}
          </select>
          <button className="admin-my-team-export-btn">
            <Download size={16} /> Export
          </button>
        </div>
      </div>

      <div className="admin-my-team-filters">
        <div className="admin-my-team-filter-group">
          <label>Date Range</label>
          <select className="admin-my-team-filter-select">
            <option>Last 30 Days</option>
            <option>Last 60 Days</option>
            <option>Last 90 Days</option>
            <option>All Time</option>
          </select>
        </div>

        <div className="admin-my-team-filter-group">
          <label>Course Type</label>
          <select className="admin-my-team-filter-select">
            <option>All Type</option>
            <option>Technical</option>
            <option>Soft Skills</option>
            <option>Compliance</option>
          </select>
        </div>

        <div className="admin-my-team-filter-group">
          <label>Status</label>
          <select className="admin-my-team-filter-select">
            <option>All Status</option>
            <option>Completed</option>
            <option>In Progress</option>
            <option>Not Started</option>
          </select>
        </div>

        <div className="admin-my-team-filter-group">
          <label>Search</label>
          <input
            type="text"
            className="admin-my-team-search-input"
            placeholder="Search courses..."
          />
        </div>
      </div>

      <div className="admin-my-team-table-container">
        <table className="admin-my-team-table">
          <thead>
            <tr>
              <th>COURSE</th>
              <th>TYPE</th>
              <th>STATUS</th>
              <th>PROGRESS</th>
              <th>SCORE</th>
              <th>ENROLLED</th>
              <th>DUE DATE</th>
              <th>COMPLETED</th>
              <th>CERTIFICATE</th>
            </tr>
          </thead>
          <tbody>
            {learningHistory?.map(item => (
              <tr key={item.id}>
                <td>
                  <div className="admin-my-team-course-info">
                    <div className="admin-my-team-course-icon">
                      <BookOpen size={20} />
                    </div>
                    <span>{item.name}</span>
                  </div>
                </td>
                <td>{item.type}</td>
                <td>
                  <span className={`admin-my-team-status-badge ${
                    item.status === 'Completed' ? 'admin-my-team-status-completed' : 'admin-my-team-status-progress'
                  }`}>
                    {item.status}
                  </span>
                </td>
                <td>
                  <div className="admin-my-team-progress-cell">
                    <span>{item.progress}%</span>
                    <div className="admin-my-team-progress-bar">
                      <div
                        className="admin-my-team-progress-fill"
                        style={{ width: `${item.progress}%` }}
                      />
                    </div>
                  </div>
                </td>
                <td>{item.score}</td>
                <td>{item.enrolled}</td>
                <td>
                  {item.overdue ? (
                    <span style={{ color: '#dc2626', fontWeight: 600 }}>
                      {item.dueDate} (overdue)
                    </span>
                  ) : (
                    <span>{item.dueDate}</span>
                  )}
                </td>
                <td>{item.completed}</td>
                <td>
                  {item.certificate && (
                    <button className="admin-my-team-view-cert-btn">
                      <Award size={14} /> View
                    </button>
                  )}
                  {!item.certificate && <span>-</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LearningHistoryTab;
